import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { Env } from '../../../env/env';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {

  const storageService = inject(StorageService);

  if (storageService.token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${storageService.token}`,
        ['X-Tenant-ID']: Env.tanant
      },
    });
  } else {
    req = req.clone({
      setHeaders: {
        ['X-Tenant-ID']: Env.tanant
      },
    });
  }

  return next(req);
};
